import React, { createContext, useLayoutEffect, useState, useMemo, FC, ReactNode } from 'react';
import useDeviceScreen from '../hooks/useDeviceScreen';

export interface IThemeContextProps {
  asideStatus: boolean;
  darkModeStatus: boolean;
  fullScreenStatus: boolean;
  leftMenuStatus: boolean;
  mobileDesign: boolean;
  rightMenuStatus: boolean;
  rightPanel: boolean;
  setAsideStatus: (value: ((prevState: boolean) => boolean) | boolean) => void;
  setDarkModeStatus: (value: ((prevState: boolean) => boolean) | boolean) => void;
  setFullScreenStatus: (value: ((prevState: boolean) => boolean) | boolean) => void;
  setLeftMenuStatus: (value: ((prevState: boolean) => boolean) | boolean) => void;
  setRightMenuStatus: (value: ((prevState: boolean) => boolean) | boolean) => void;
  setRightPanel: (value: ((prevState: boolean) => boolean) | boolean) => void;
}
const ThemeContext = createContext<IThemeContextProps>({} as IThemeContextProps);

interface IThemeContextProviderProps {
  children: ReactNode;
}
export const ThemeContextProvider: FC<IThemeContextProviderProps> = ({ children }) => {
  const deviceScreen = useDeviceScreen();
  // @ts-ignore
  const mobileDesign = deviceScreen?.width <= process.env.REACT_APP_MOBILE_BREAKPOINT_SIZE;

  const [darkModeStatus, setDarkModeStatus] = useState(
    localStorage.getItem('aip_darkModeStatus')
      ? localStorage.getItem('aip_darkModeStatus') === 'true'
      : process.env.REACT_APP_DARK_MODE === 'true',
  );

  useLayoutEffect(() => {
    localStorage.setItem('aip_darkModeStatus', darkModeStatus.toString());
  }, [darkModeStatus]);

  const [fullScreenStatus, setFullScreenStatus] = useState(false);

  const [leftMenuStatus, setLeftMenuStatus] = useState(false);
  const [rightMenuStatus, setRightMenuStatus] = useState(false);
  // localStorage key 升级 v1 → v2:跟随"默认展开"+移除 hover-expand 改动统一重置
  // 老用户的 `aip_asideStatus` 偏好作废,首次访问按新默认值(桌面端默认展开)
  const [asideStatus, setAsideStatus] = useState(
    localStorage.getItem('aip_asideStatus_v2')
      ? localStorage.getItem('aip_asideStatus_v2') === 'true'
      : // 默认:桌面端(>= 768) 展开;仅移动端默认收起避免遮挡内容
        // @ts-ignore
        deviceScreen?.width >= process.env.REACT_APP_MOBILE_BREAKPOINT_SIZE,
  );
  useLayoutEffect(() => {
    localStorage.setItem('aip_asideStatus_v2', asideStatus?.toString());
  }, [asideStatus]);

  const [rightPanel, setRightPanel] = useState(false);

  useLayoutEffect(() => {
    // @ts-ignore
    if (deviceScreen?.width >= process.env.REACT_APP_ASIDE_MINIMIZE_BREAKPOINT_SIZE) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      if (localStorage.getItem('aip_asideStatus_v2') === 'true') setAsideStatus(true);
      setLeftMenuStatus(false);
      setRightMenuStatus(false);
    }
    return () => {
      setAsideStatus(false);
    };
  }, [deviceScreen.width]);

  const values: IThemeContextProps = useMemo(
    () => ({
      mobileDesign,
      darkModeStatus,
      setDarkModeStatus,
      fullScreenStatus,
      setFullScreenStatus,
      asideStatus,
      setAsideStatus,
      leftMenuStatus,
      setLeftMenuStatus,
      rightMenuStatus,
      setRightMenuStatus,
      rightPanel,
      setRightPanel,
    }),
    [
      asideStatus,
      darkModeStatus,
      fullScreenStatus,
      leftMenuStatus,
      mobileDesign,
      rightMenuStatus,
      rightPanel,
    ],
  );

  return <ThemeContext.Provider value={values}>{children}</ThemeContext.Provider>;
};

export default ThemeContext;
